import React from 'react';
import { Compass, BookOpen, Award } from 'lucide-react';
import { ViewType } from '../types';

interface MobileNavProps {
  currentView: ViewType;
  onNavigate: (view: ViewType) => void;
}

export const MobileNav: React.FC<MobileNavProps> = ({ currentView, onNavigate }) => {
  const items: { view: ViewType; label: string; icon: React.ReactNode }[] = [
    {
      view: 'home',
      label: 'Nhập cuộc',
      icon: <Compass className="w-5 h-5" />,
    },
    {
      view: 'journey',
      label: 'Bộ sưu tập',
      icon: <BookOpen className="w-5 h-5" />,
    },
    {
      view: 'summary',
      label: 'Dấu ấn',
      icon: <Award className="w-5 h-5" />,
    },
  ];

  return (
    <nav
      aria-label="Điều hướng di động"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-[#1d1519]/95 backdrop-blur-md border-t border-[#755d55] pb-[max(0.5rem,env(safe-area-inset-bottom,8px))] shadow-2xl"
    >
      <div className="grid grid-cols-3 h-14">
        {items.map(({ view, label, icon }) => {
          const isActive = currentView === view;
          return (
            <button
              key={view}
              onClick={() => onNavigate(view)}
              className={`flex flex-col items-center justify-center gap-1 transition-all ${
                isActive
                  ? 'text-[#e6ba55] font-bold'
                  : 'text-[#cdbdaf] hover:text-[#fff4dd]'
              }`}
            >
              <span className={isActive ? 'scale-110 transition-transform' : ''}>
                {icon}
              </span>
              <span className="text-[11px] font-medium tracking-wide">
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};
